import type {ReactElement} from 'react';
import React from 'react';
import {getCurrentPage} from '@Components/poster-editor/poster-editor-reducer';
import {BackgroundTypeName} from '@PosterWhiteboard/page/background/background.class';
import {BaseTintOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-tint-option';
import {useAppSelector} from '@/hooks';
import type {RGBA} from '@Utils/color.util';

interface ImageBgTintOptionProps {
  onClickColorFill(): void;
}

export function ImageBgTintOption({...props}: ImageBgTintOptionProps): ReactElement<any> | null {
  const currentPageObject = useAppSelector(getCurrentPage);
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();

  if (!currentPageObject) {
    return null;
  }

  if (currentPageObject.background.details.type !== BackgroundTypeName.IMAGE) {
    return null;
  }

  const onToggleTint = (): void => {
    if ('imageBackgroundItemObject' in currentPageObject.background.details) {
      void currentPage?.background.updateFromObject({
        details: {
          imageBackgroundItemObject: {
            effects: {
              tint: !currentPageObject.background.details.imageBackgroundItemObject.effects.tint,
            },
          },
        },
      });
    } else {
      throw new Error('imageBackgroundItemObject does not exist in page background details');
    }
  };

  const onClickColorFill = (): void => {
    props.onClickColorFill();
  };

  const onUpdateOpacity = (tintOpacity: number, undoable = true): void => {
    if ('imageBackgroundItemObject' in currentPageObject.background.details) {
      const tintColor = currentPageObject.background.details.imageBackgroundItemObject.effects.tintColor.slice() as RGBA;
      tintColor[3] = tintOpacity;
      void currentPage?.background.updateFromObject(
        {
          details: {
            imageBackgroundItemObject: {
              effects: {
                tintColor,
              },
            },
          },
        },
        {undoable}
      );
    } else {
      throw new Error('imageBackgroundItemObject does not exist in page background details');
    }
  };

  return (
    <BaseTintOption
      tint={currentPageObject.background.details.imageBackgroundItemObject.effects.tint}
      tintOpacity={currentPageObject.background.details.imageBackgroundItemObject.effects.tintColor[3]}
      tintColor={currentPageObject.background.details.imageBackgroundItemObject.effects.tintColor}
      onToggleTint={onToggleTint}
      onClickColorFill={onClickColorFill}
      updateOpacity={onUpdateOpacity}
    />
  );
}
